module.exports = __webpack_public_path__ + "officialStatic/img/school1Logo.06ae4f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/wireless/school1Logo.png
// module id = 1FLp
// module chunks = 0